<script lang="ts" setup>
import {NewFLowStep} from "~/models/enums";
import {useUserStore} from "~/store/user";

const userStore = useUserStore()
const currentStep = computed(() => userStore.userProfile?.step as number);
const stepItems = computed(() => [
  // {
  //   title: "آشنایی با آکادمی یاسان",
  //   href: "/new/intro",
  //   disabled: currentStep.value < NewFLowStep.Introduction,
  //   icon: "mdi:play-circle-outline",
  // },
  {
    title: "تکمیل مشخصات",
    href: "/new/complete-info",
    disabled: currentStep.value < NewFLowStep.Registration,
    icon: "mdi:account-edit-outline",
  },
  // {
  //   title: "انتخاب مسیر",
  //   href: "/new/road-map",
  //   disabled: currentStep.value < NewFLowStep.ChooseMeeting,
  //   icon: "mdi:flag-outline-variant",
  // },
  {
    title: "تهیه اشتراک و شروع یادگیری",
    href: "/new/plans",
    disabled: currentStep.value < NewFLowStep.ChoosePlan,
    icon: "mdi:school-outline",
  },
]);
</script>

<template>
  <header class="d-flex align-center justify-center bg-white py-5 px-4 elevation-1">
    <VImg src="/new/images/svg/logo.svg" width="140" height="32"/>
  </header>
  <div class="py-2 bg-grey-lighten-5">
    <VContainer class="pa-2">
      <ul class="d-flex align-center ga-1 ga-md-3">
        <LayoutsRegisterFlowStepItem
            v-for="stepItem in stepItems"
            :key="stepItem.href"
            :title="stepItem.title"
            :href="stepItem.href"
            :disabled="stepItem.disabled"
            :icon="stepItem.icon"
        />
      </ul>
    </VContainer>
  </div>
</template>
